import { useTonAddress } from '@tonconnect/ui-react'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useWalletBalance } from '../../../hooks'
import { type ECurrency, EModalName } from '../../../types/enums'
import { Button, ToggleSwitch } from '../../atoms'
import { CountdownTimer, InputWrapper, Money } from '..'
import {
  autoBuyInOption,
  buyInButton,
  buyInButtons,
  digitsStyle,
  formStyle,
  inputContainer,
  modalConent,
  numberInput,
  submitButton,
} from './index.css'

export const ModalBuyIn = (props: {
  currency: ECurrency
  reserveMs: number
  minBuyIn: number
  maxBuyIn: number
  close: (result?: number) => void
}) => {
  const { t } = useTranslation()
  const userTonAddress = useTonAddress()
  const walletBalance = useWalletBalance(props.currency, userTonAddress)
  const [result, setResult] = useState<number | undefined>(undefined)

  const onClickButton = (
    e: React.MouseEvent<HTMLButtonElement, MouseEvent>,
    amount: number,
  ) => {
    e.stopPropagation()
    setResult(amount)
  }

  return (
    <form
      className={formStyle}
      onSubmit={() => props.close(result || 0)}
    >
      <div className={modalConent}>
        {walletBalance?.data?.ok ? (
          <span>
            {`${t('modal.buyIn.label.currentBalance')}: `}
            <span className={digitsStyle}>
              <Money
                withIcon={true}
                currency={props.currency}
                inBigBlinds={false}
              >
                {walletBalance.data.result}
              </Money>
            </span>
          </span>
        ) : null}

        <span>
          <div>
            <span>{t('modal.buyIn.label.timeReserved')}: </span>
            <span className={digitsStyle}>
              <CountdownTimer remainingMilliseconds={props.reserveMs} />
            </span>
          </div>
        </span>
        <div className={inputContainer}>
          <InputWrapper
            className={numberInput}
            type='number'
            min={props.minBuyIn}
            max={Math.max(props.maxBuyIn, walletBalance?.data?.result || 0)}
            step={0.01}
            value={result}
            required
            hideNumberArrows={true}
            onChange={setResult}
          >
            <div className={buyInButtons}>
              <Button
                className={buyInButton}
                variant='bordered'
                analytic={{
                  name: 'min',
                  params: {
                    modal: EModalName.TABLE_BUY_IN,
                  },
                }}
                onClick={(e) => onClickButton(e, props.minBuyIn)}
              >
                {t('modal.buyIn.button.min')}
              </Button>
              <Button
                className={buyInButton}
                variant='bordered'
                analytic={{
                  name: 'max',
                  params: {
                    modal: EModalName.TABLE_BUY_IN,
                  },
                }}
                onClick={(e) => onClickButton(e, props.maxBuyIn)}
              >
                {t('modal.buyIn.button.max')}
              </Button>
            </div>
          </InputWrapper>
        </div>
        {/* <div
          style={{ opacity: 0.5 }}
          className={autoBuyInOption}
        >
          <span>Auto buy-in to max stack in every hand</span>
          <ToggleSwitch
            checked={true}
            readOnly={true}
          />
        </div> */}
      </div>
      <Button
        type='submit'
        variant='primary'
        analytic={{
          name: 'play',
          params: {
            modal: EModalName.TABLE_BUY_IN,
            buyIn: result,
            currency: props.currency,
          },
        }}
        className={submitButton}
      >
        {t('modal.buyIn.button.play')}
      </Button>
    </form>
  )
}
